import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IFileData, IFileDataCrud } from 'clickNgo/models/file'
import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { mapLegalFileFromCrud } from './mapping/mapLegalFileFromCrud'

export const fetchLegalFileByPartnerId = (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<IFileData[]> => {
  if (!partnerId) {
    return Promise.resolve([])
  }

  const crud: Crud<IFileDataCrud> = CrudStore.get<IFileDataCrud>(
    CrudStoreItem.LegalAttachments,
    options?.cacheKey
  )
  const page = 0
  const pageSize = 100
  const filterByPartnerId = {
    operator: Operator.EQUAL,
    field: 'PartnerId',
    value: partnerId,
  }
  const filterByType = {
    operator: Operator.EQUAL,
    field: 'Type',
    value: 'Legal',
  }

  crud.setFilter({
    logic: Logic.AND,
    filters: [filterByPartnerId, filterByType],
  })

  crud.setPaging({ page, pageSize })

  return crud
    .fetch({ skipHierarchyFilter: options?.skipHierarchyFilter, force: options?.isForce })
    .then(({ items = [] }) => {
      return mapLegalFileFromCrud(items)
    })
}
